/**
 * CART "ES REGALO" FIELD — Fabletics GT (Essence theme)
 *
 * Keeps the cart attribute "regalo" in sync with the checkbox, always as the
 * string "true" or "false" — the shape the backend reads on the order.
 * Shopify copies cart attributes onto the order as note attributes, so the
 * value reaches Admin and the ERP without anything else being involved.
 *
 * Document-level delegation, like cart-nit-validation.js: the cart modal is
 * replaced wholesale by the Section Rendering API on every cart change, so a
 * listener bound to the element itself would not survive.
 *
 * The attribute is written even when the shopper never touches the checkbox,
 * so the key is never missing from the order. Checking out from the drawer
 * would not post it: that form only wraps the button.
 */

(function () {
  'use strict';

  var ATTRIBUTE_NAME = 'regalo';
  var FIELD_SELECTOR = '.cart-gift-field input.cart-gift-field__input';
  var TRUE = 'true';
  var FALSE = 'false';

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart.js';
  }

  /**
   * Persist the flag through the Cart API.
   * Only our key travels: /cart/update.js merges by key, so "nit" and
   * "MID Productos" are left alone.
   * @param {boolean} checked
   * @returns {Promise<void>}
   */
  function save(checked) {
    var attributes = {};
    attributes[ATTRIBUTE_NAME] = checked ? TRUE : FALSE;
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/update.js respondió ' + response.status);
    });
  }

  // ─── Error UI ─────────────────────────────────────────────────────────────

  function showError(input, message) {
    var errorEl = document.getElementById(input.id + '-error');
    input.setAttribute('aria-invalid', 'true');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.removeAttribute('hidden');
    }
  }

  function clearError(input) {
    var errorEl = document.getElementById(input.id + '-error');
    input.removeAttribute('aria-invalid');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.setAttribute('hidden', '');
    }
  }

  /* En /cart conviven la casilla de la página y la del drawer. Sin esto, lo
     que marca el cliente en una no existe para la otra. */
  function setAll(checked) {
    var all = document.querySelectorAll(FIELD_SELECTOR);
    for (var i = 0; i < all.length; i++) {
      all[i].checked = checked;
      clearError(all[i]);
    }
  }

  // ─── Interaction ──────────────────────────────────────────────────────────

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('cart-gift-field__input')) return;

    var checked = input.checked;
    setAll(checked);

    /* Si el carrito rechaza el cambio revertimos la casilla: dejarla marcada
       haría creer que el pedido va como regalo cuando la orden no lo lleva. */
    save(checked).catch(function () {
      setAll(!checked);
      var wrapper = input.closest('.cart-gift-field');
      showError(input, (wrapper && wrapper.dataset.giftErrorSave) || 'No pudimos guardar la opción de regalo.');
    });
  });

  // ─── Default value ────────────────────────────────────────────────────────

  /* Escribe "false" cuando el atributo todavía no existe, para que la orden
     nunca llegue sin la key. Se hace una sola vez por carga. */
  var defaultWritten = false;

  function writeDefaultOnce() {
    if (defaultWritten) return;
    defaultWritten = true;
    save(false).catch(function () {
      /* La próxima carga o el próximo add-to-cart vuelven a intentarlo. */
      defaultWritten = false;
    });
  }

  function ensureDefaultFromDom() {
    var wrapper = document.querySelector('.cart-gift-field');
    if (!wrapper) return;
    var current = wrapper.dataset.giftCurrent;
    if (current !== TRUE && current !== FALSE) writeDefaultOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureDefaultFromDom);
  } else {
    ensureDefaultFromDom();
  }

  /* Carrito nuevo: la opción de regalo de una compra anterior no debe
     arrastrarse a la siguiente. Mismo criterio que el NIT. */
  document.addEventListener('product:added-to-cart', function () {
    fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        var current = (cart.attributes && cart.attributes[ATTRIBUTE_NAME]) || '';

        if (cart.item_count === 1) {
          setAll(false);
          if (current !== FALSE) save(false).catch(function () {});
          return;
        }

        if (current !== TRUE && current !== FALSE) save(false).catch(function () {});
      })
      .catch(function () {});
  });
})();
